import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import CoverSingleCardTopAb from "@/components/molecules/quote-section/quote-cover/cover-level-selection-card-top/cover-level-selection-card-top-ab";
import { OptimizelyExperimentsEnum } from "@/config/app-constant";
import { APPLICATION, PRODUCT, VARIANT_FLOW } from "@/constants";
import { CoverSingleCardPropsType } from "@/schema/quote-page/page.schema";
import { RootState } from "@/store/root-reducer";
import { DynamicCoverLimitProduct } from "@/types/DynamicCoverLimitProductType";
import { PolicyPackagePrice } from "@/types/PolicyPackagePriceType";

import Styles from "./cover-level-selection-card.module.css";
import CoverSingleBottom, {
  DrawerData,
} from "../cover-level-selection-card-bottom/cover-level-selection-card-bottom";
import CoverSingleCardTop from "../cover-level-selection-card-top/cover-level-selection-card-top";

function CoverSingleCard({
  bottomSectionclassName = "",
  cardBottomData = {},
  cardTopData = {},
  defaqtoStarts,
  whichBestBuyBadge,
  id = 0,
  isSelect = false,
  isHideCard,
  keyValue,
  onlineExclusiveBannerLabel,
  isSocialProofChipActive = false,
  chipTopText = "",
  chipBottomText = "",
  type = "",
  onSelect,
  onTripTypeToggle,
}: Readonly<CoverSingleCardPropsType>) {
  const { attributes, referenceId } = useSelector(
    (state: RootState) => state.quote
  );
  const isAbVariant = useMemo(() => {
    return (
      typeof window !== "undefined" &&
      localStorage.getItem(OptimizelyExperimentsEnum.RENEWAL_COVER_LEVEL) &&
      localStorage.getItem(OptimizelyExperimentsEnum.RENEWAL_COVER_LEVEL) ===
        VARIANT_FLOW &&
      APPLICATION === "renewal" &&
      PRODUCT === "staysure"
    );
  }, []);

  const cover: PolicyPackagePrice | undefined =
    attributes?.priceResult?.policyPackagePrice.find(
      (coverPackage: PolicyPackagePrice) =>
        coverPackage?.policyType === type &&
        coverPackage?.policyPackage === keyValue
    );

  const dynamicCoverLimit =
    attributes?.priceResult?.dynamicCoverLimit?.[0]?.product?.find(
      (coverPackage: DynamicCoverLimitProduct) =>
        coverPackage?.policyType === type &&
        coverPackage?.policyPackage === keyValue
    );

  // Check if card should be hidden based  isHideCard
  const cardTypeKey = keyValue?.toLowerCase() as
    | "basic"
    | "comprehensive"
    | "signature"
    | "essentials"
    | "classic"
    | "deluxe";
  const shouldHideCard =
    isHideCard && cardTypeKey && isHideCard[cardTypeKey] === true;
  if (shouldHideCard) {
    return null;
  }

  return (
    <div
      data-ab-id="cover-level-selection-card-root"
      data-testid="CoveringCard-testid"
      className={`grid grid-cols-1 ${
        isSelect ? "my-[16px] relative top-[8px] " : "my-[24px]"
      }`}
    >
      <div
        data-ab-id="cover-level-selection-card-sub-root"
        className={`w-auto rounded-[16px] bg-transparent ${
          isSelect
            ? "!shadow-[0px_0px_18px_0px_rgba(15,23,42,0.15)] relative top-[-8px]"
            : ""
        } `}
      >
        {isAbVariant ? (
          <CoverSingleCardTopAb
            isSocialProofChipActive={isSocialProofChipActive}
            chipTopText={chipTopText}
            type={type}
            cardTopData={cardTopData}
            keyValue={keyValue}
            defaqtoStarts={defaqtoStarts}
            cover={cover}
            referenceId={referenceId}
            id={id}
            onTripTypeToggle={onTripTypeToggle}
          />
        ) : (
          <CoverSingleCardTop
            onlineExclusiveBannerLabel={onlineExclusiveBannerLabel}
            type={type}
            isSelect={isSelect}
            cardTopData={cardTopData}
            keyValue={keyValue}
            onSelect={(val, state, index) =>
              onSelect && onSelect(val, state, index)
            }
            defaqtoStarts={defaqtoStarts}
            whichBestBuyBadge={whichBestBuyBadge}
            selectState={isSelect}
            cover={cover}
            referenceId={referenceId}
            id={id}
            onTripTypeToggle={onTripTypeToggle}
          />
        )}
        <div
          className={`${bottomSectionclassName} bg-surface-neutral-option-1 h-fit w-full rounded-b-[16px] ${
            isSelect && APPLICATION === "renewal"
              ? `${keyValue.toLocaleLowerCase()} ${Styles.border}`
              : "border-[1px] border-t-[0px] border-border-default"
          } p-spacing-m pb-spacing-l `}
        >
          <CoverSingleBottom
            tableDta={cardBottomData?.tableData ?? []}
            changeBtnLabel={cardBottomData?.changeBtnLabel}
            seeMoreDetailsBtnLabel={cardBottomData?.seeMoreDetailsBtnLabel}
            dynamicCoverLimit={dynamicCoverLimit || null}
            policyPackage={keyValue}
            drawerData={(cardBottomData?.drawerData as DrawerData) ?? undefined}
            setCancellationCoverOpen={cardBottomData?.setCancellationCoverOpen}
            setDynamicCoverLimit={cardBottomData?.setDynamicCoverLimit}
            setCancelltionChangeCoverType={
              cardBottomData?.setCancelltionChangeCoverType
            }
            id={id}
            keyValue={keyValue}
            selectBtnActiveLable={cardBottomData?.selectBtnActiveLable}
            selectBtnInactiveLable={cardBottomData?.selectBtnInactiveLable}
            isLoading={cardBottomData?.isLoading}
            selectState={isSelect}
            onSelect={(val, state, index) =>
              onSelect && onSelect(val, state, index)
            }
            referenceId={referenceId}
            isSocialProofChipActive={isSocialProofChipActive}
            chipBottomText={chipBottomText}
            cardTitle={cardTopData?.cardTitle}
          />
        </div>
      </div>
    </div>
  );
}

export default CoverSingleCard;
